// Dữ liệu mẫu cho các danh mục và địa điểm
export const mockData = [
  {
    category: "Ăn uống",
    featured: {
      name: "Bánh mì pate",
      likes: 11,
      location: "Hà Nội",
      distance: "5.3km",
      image: "/images/banhmipate.png",
    },
    subcategories: [
      {
        name: "Đồ Ý",
        places: [
          {
            name: "Mỳ Ý",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/miy.png",
          },
          {
            name: "Pizza",
            likes: 23,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/pizza.png",
          },
          {
            name: "Bánh ngọt",
            likes: 3,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/banhngot.png",
          },
        ],
      },
      {
        name: "Quán cà phê",
        places: [
          {
            name: "Quán của Mình",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/quancuaminh.png",
          },
          {
            name: "Eden Coffee",
            likes: 23,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/edencf.png",
          },
          {
            name: "Aroi Dessert Cafe",
            likes: 3,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/aroicf.png",
          },
        ],
      },
      {
        name: "Quán ăn sáng",
        places: [
          {
            name: "Phở Thìn",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/phothin.png",
          },
          {
            name: "Mì Cá SakaMi",
            likes: 23,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/sakami.png",
          },
          {
            name: "Bánh Bao",
            likes: 3,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/banhbao.png",
          },
        ],
      },
      {
        name: "Nhà hàng",
        places: [
          {
            name: "Nhà hàng Sapa",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/nhahangsapa.png",
          },
          {
            name: "Lương Sơn Quán",
            likes: 23,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/luongsonquan.png",
          },
          {
            name: "Ao Quán",
            likes: 3,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/aoquan.png",
          },
        ],
      },
    ],
  },
  {
    category: "Mua sắm",
    subcategories: [
      {
        name: "Nhà sách",
        places: [
          {
            name: "Fahasa",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/fahasa.png",
            iconBg: "#E74C3C",
          },
        ],
      },
    ],
  },
  {
    category: "Sức khỏe",
    subcategories: [
      {
        name: "Chăm sóc cá nhân",
        places: [
          {
            name: "Quán cắt tóc",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/fahasa.png",
            iconBg: "#E74C3C",
          },
        ],
      },
    ],
  },
  {
    category: "Dịch vụ",
    featured: {
      name: "Chăm sóc thú cưng",
      likes: 11,
      location: "Hà Nội",
      distance: "5.3km",
      image: "/images/chamsocchomeo.png",
    },
    subcategories: [],
  },
  {
    category: "Dịch vụ nhà cửa",
    subcategories: [
      {
        name: "Dịch vụ nhà cửa",
        places: [
          {
            name: "Dọn nhà thuê",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/donnhathue.png",
            iconBg: "#3498DB",
          },
        ],
      },
      {
        name: "Nhà cung cấp dịch vụ",
        places: [
          {
            name: "Đặt chỗ đi dao",
            likes: 5,
            location: "Hà Nội",
            distance: "5.3km",
            image: "/images/donnhathue.png",
            iconBg: "#F1C40F",
          },
        ],
      },
    ],
  },
];

export const mockTabs = [
  { label: "Tất cả" },
  { label: "Sức khỏe" },
  { label: "Dịch vụ" },
  { label: "Ăn uống" },
  { label: "Mua sắm" },
];
